import Vue from 'vue'
import App from './App.vue'
import router from './router'

/*Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

 */
//import store from './store'
import Axios from 'axios'
import VueResource from "vue-resource"

Vue.prototype.$http = Axios;

Vue.use(VueResource);

Vue.config.productionTip = false






new Vue({
  router,
  /*  store,*/
  render: h => h(App)
}).$mount('#app')